import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PyStateUtils } from '../../../../../../core/state';
import { StatisticsEntry, StatisticsQueryParams, StatisticsQueryType, StatisticsSoldTo } from '../../model';
import { STATISTICS_OVERVIEW, STATISTICS_SOLDTO } from '../statistics-state';

export enum StatisticsActionTypes {
  LoadStatisticsSoldTos = '[Statistics] Load sold-tos',
  LoadStatisticsSoldTosFail = '[Statistics] Load sold-tos fail',
  LoadStatisticsSoldTosSuccess = '[Statistics] Load sold-tos success',

  LoadStatisticsOverview = '[Statistics] Load overview',
  LoadStatisticsOverviewFail = '[Statistics] Load overview fail',
  LoadStatisticsOverviewSuccess = '[Statistics] Load overview success',

  QueryStatistics = '[Statistics] Query',
  QueryStatisticsFail = '[Statistics] Query fail',
  QueryStatisticsSuccess = '[Statistics] Query success',

  UpdateStatisticsQueryParameters = '[Statistics] Update query parameters',
}

export class LoadStatisticsSoldTos extends StateUtils.LoaderLoadAction {
  readonly type = StatisticsActionTypes.LoadStatisticsSoldTos;

  constructor(public payload: string) {
    super(STATISTICS_SOLDTO);
  }
}

export class LoadStatisticsSoldTosFail extends PyStateUtils.LoaderFailAction {
  readonly type = StatisticsActionTypes.LoadStatisticsSoldTosFail;

  constructor(public payload?: any) {
    super(STATISTICS_SOLDTO, payload);
  }
}

export class LoadStatisticsSoldTosSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = StatisticsActionTypes.LoadStatisticsSoldTosSuccess;

  constructor(public payload: StatisticsSoldTo[]) {
    super(STATISTICS_SOLDTO);
  }
}

export class LoadStatisticsOverview extends StateUtils.LoaderLoadAction {
  readonly type = StatisticsActionTypes.LoadStatisticsOverview;

  constructor(public payload: string) {
    super(STATISTICS_OVERVIEW);
  }
}

export class LoadStatisticsOverviewFail extends PyStateUtils.LoaderFailAction {
  readonly type = StatisticsActionTypes.LoadStatisticsOverviewFail;

  constructor(public payload?: any) {
    super(STATISTICS_OVERVIEW, payload);
  }
}

export class LoadStatisticsOverviewSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = StatisticsActionTypes.LoadStatisticsOverviewSuccess;

  constructor(
    public currencyIso: string,
    public payload: StatisticsEntry[]
  ) {
    super(STATISTICS_OVERVIEW);
  }
}

export class QueryStatistics extends StateUtils.LoaderLoadAction {
  readonly type = StatisticsActionTypes.QueryStatistics;

  constructor(
    public payload: {
      userId: string;
      query: StatisticsQueryType;
      queryParams: StatisticsQueryParams;
    }
  ) {
    super(payload.query);
  }
}

export class QueryStatisticsFail extends PyStateUtils.LoaderFailAction {
  readonly type = StatisticsActionTypes.QueryStatisticsFail;

  constructor(
    public query: StatisticsQueryType,
    public payload?: any
  ) {
    super(query, payload);
  }
}

export class QueryStatisticsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = StatisticsActionTypes.QueryStatisticsSuccess;

  constructor(
    public query: StatisticsQueryType,
    public payload: StatisticsEntry[]
  ) {
    super(query);
  }
}

export class UpdateStatisticsQueryParameters implements Action {
  readonly type = StatisticsActionTypes.UpdateStatisticsQueryParameters;

  constructor(public queryParams: StatisticsQueryParams) {}
}

export type StatisticsActions =
  | LoadStatisticsSoldTos
  | LoadStatisticsSoldTosFail
  | LoadStatisticsSoldTosSuccess
  | LoadStatisticsOverview
  | LoadStatisticsOverviewFail
  | LoadStatisticsOverviewSuccess
  | QueryStatistics
  | QueryStatisticsFail
  | QueryStatisticsSuccess
  | UpdateStatisticsQueryParameters;
